"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateApiOrderInput = void 0;
const addressValid_1 = require("../addressValid");
const nameValid_1 = require("../nameValid");
const phoneValid_1 = require("../phoneValid");
const emailValid_1 = require("../emailValid");
const documentValid_1 = require("../documentValid");
const luxon_1 = require("luxon");
const validateApiOrderInput = (input) => {
    const { widgetId, vehicleId, dateFrom, dateTo, startAddress, endAddress, name, surname, email, phone, driverLicense, passport, } = input;
    if (!widgetId)
        return false;
    if (!vehicleId)
        return false;
    if (!dateFrom || !luxon_1.DateTime.fromISO(dateFrom).isValid)
        return false;
    if (!dateTo || !luxon_1.DateTime.fromISO(dateTo).isValid)
        return false;
    if (!(0, addressValid_1.addressValid)(startAddress))
        return false;
    if (!(0, addressValid_1.addressValid)(endAddress))
        return false;
    if (!(0, nameValid_1.nameValid)(name))
        return false;
    if (!(0, nameValid_1.nameValid)(surname))
        return false;
    if (email && !(0, emailValid_1.emailValid)(email))
        return false;
    if (!(0, phoneValid_1.phoneValid)(phone))
        return false;
    if (driverLicense && !(0, documentValid_1.documentValid)(driverLicense))
        return false;
    if (passport && !(0, documentValid_1.documentValid)(passport))
        return false;
    return true;
};
exports.validateApiOrderInput = validateApiOrderInput;
